import {
	AudioConfig,
	ResultReason,
	SpeakerAudioDestination,
	SpeechConfig,
	SpeechSynthesizer,
} from 'microsoft-cognitiveservices-speech-sdk';
import { useState } from 'react';

const useSpeechToText = () => {
	const [hasFinishedSpeaking, setHasFinishedSpeaking] = useState<boolean>(false);

	const speechConfig = SpeechConfig.fromSubscription(
		process.env?.REACT_APP_AZURE_SPEECH_SERVICE_KEY || '',
		process.env?.REACT_APP_AZURE_SPEECH_SERVICE_REGION || ''
	);

	speechConfig.speechSynthesisVoiceName = 'en-US-JennyNeural';
	const player = new SpeakerAudioDestination();

	player.onAudioEnd = () => {
		setHasFinishedSpeaking(true);
	};

	const audioConfig = AudioConfig.fromSpeakerOutput(player);

	const synthesizer = new SpeechSynthesizer(speechConfig, audioConfig);

	const playText = (text: string): void => {
		setHasFinishedSpeaking(false);
		synthesizer.speakTextAsync(text, (result: any) => {
			if (result.reason === ResultReason.SynthesizingAudioCompleted) synthesizer.close();
		});
	};

	return {
		playText,
		hasFinishedSpeaking,
	};
};

export default useSpeechToText;
